import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const MonitoringMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./MonitoringMain'),
                'monitoring-main',
            ) as any,
    ),
);

export default MonitoringMainLazy;
